import more from '@disy/cadenza-icons/more.svg';

import type { ButtonSize } from 'ui/button/button';
import { createIconButton } from 'ui/button/button';

import { array } from 'cadenza/utils/array-util';
import { icon } from 'cadenza/utils/icon/icon';

import i18n from './more-actions-button.properties';

export function createMoreActionsButton(
  label: string,
  { size, styleClass }: { size?: ButtonSize; styleClass?: string | string[] } = {},
) {
  return createIconButton(icon(more), i18n('moreActions'), {
    variant: 'borderless',
    size,
    styleClass: [...array(styleClass), 'more-action', 'is-hover-visible'],
    attrs: {
      'aria-haspopup': 'menu',
      'aria-label': `${label} - ${i18n('moreActions')}`,
    },
  });
}
